import { render, staticRenderFns } from "./ItemInfoViewLayout.vue?vue&type=template&id=20e69497&scoped=true"
import script from "./ItemInfoViewLayout.vue?vue&type=script&lang=js"
export * from "./ItemInfoViewLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e69497",
  null
  
)

export default component.exports